import React, { useState } from "react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { removeCookie } from "../../../utils/cookies";
// layout
import { colors } from "../constants";
import Wrapper from "../wrapper";
// assets
import shortLogo from "../../../assets/logos/short-logo.svg";
import evalLogo from "../../../assets/logos/mentalia-test-logo-short.svg";

const Header = ({ showUserInfo = true }) => {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const logout = () => {
    removeCookie("userId");
    removeCookie("userToken");

    // // Redux action
    dispatch({
      type: "SET_USER_INFO",
      payload: {},
    });
  };

  return (
    <HeaderStyled>
      <Wrapper>
        <div className="container">
          <div className="test-group">
            <img src={evalLogo} alt="mentalia" />
          </div>
          {user.token && showUserInfo ? (
            <div className="user-group desktop">
              <div>
                <p className="avatar-name">Evaluación de {user.name}</p>
                {/* <p className="logout" onClick={() => logout()}>
                  Cerrar sesión
                </p> */}
              </div>
              <img
                className="avatar-image"
                src={`https://pruebas.mentalia.mx${user.avatar}`}
                alt="avatar"
              />
            </div>
          ) : null}
        </div>
      </Wrapper>
    </HeaderStyled>
  );
};

const HeaderStyled = styled.header`
  background-color: ${colors.primary};
  z-index: 2;

  .container {
    align-items: center;
    display: flex;
    height: 80px;
    /* justify-content: space-between; */
    width: 100%;
    margin: 0 auto;
  }

  .test-group,
  .user-group {
    align-items: center;
    color: ${colors.lightText};
    display: flex;
  }

  .title {
    color: ${colors.lightText};
    font-size: 1.5em;
    margin: 0 10px;
  }

  .evaluation {
    font-weight: 400;
  }

  .avatar-name,
  .logout {
    margin: 0 0 0 10px;
  }

  .logout {
    cursor: pointer;
    :hover {
      transform: scale(1.05);
    }
  }

  .avatar-image {
    border-radius: 100%;
    max-height: 50px;
    margin-left: 1em;
  }

  @media (max-width: 460px) {
    .desktop {
      display: none;
    }
  }
`;

export default Header;
